module.exports = __webpack_public_path__ + "static/media/sensa.a16baeb0.svg";